import { useEffect, useState } from "react";
import { storageData } from "../../services/Services";
import RQ_Header from "./RQ_Header";
import FormContainer from "../../components/RenewalQuestionnaireComp/FormContainer";
import SaveHelpContainer from "../../components/RenewalQuestionnaireComp/SaveHelpContainer";
import SignAndAgree_Main from "../../components/RenewalQuestionnaireComp/Agreements/SignAndAgree_Main";

const RQ_Sign = () => {
    const [RQ_Data, setRQ_Data] = useState({});
    const user = storageData.getItem('userData')
    const userData = JSON.parse(user)

    useEffect(() => {
        if (storageData.getItem("sessionDataRQ")) {
            setRQ_Data(storageData.getItem("sessionDataRQ"))
        }
    }, [])

    return (
        <>
            <div className="container widthScreen">
                <RQ_Header userData={userData} screen={'sign'} />

                <div className="col-12 mt-2 row">
                    <FormContainer Content={SignAndAgree_Main} params={RQ_Data} saveRQ={setRQ_Data} />
                    <SaveHelpContainer />
                </div>
            </div>
        </>
    )
}

export default RQ_Sign